import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import { Container, Row, Nav, Navbar } from 'react-bootstrap';

export default (props) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
      logoSVG: file(relativePath: { eq: "logo.svg" }) {
        publicURL
      }
      allMenuMain {
        nodes {
          title
          relative
        }
      }
    }
  `);
  return (
    <Container style={{ paddingTop: 0, paddingBottom: 0 }}>
      <Row>
        <Navbar expand="lg" style={{ width: '100%' }}>
          <Link
            to="/"
            style={{ color: `white`, textDecoration: `none` }}
          >
            <Navbar.Brand>
              <img
                src={data.logoSVG.publicURL}
                alt={data.site.siteMetadata.title}
                style={{ width: '150px', marginBottom: 0 }}
              />
            </Navbar.Brand>
          </Link>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ml-auto">
              {data.allMenuMain.nodes.map((edge, key) => {
                return (
                  <Link
                    to={edge.relative}
                    className="nav-link"
                    key={key}
                    activeClassName="active"
                  >
                    {edge.title}
                  </Link>
                );
              })}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </Row>
    </Container>
  );
};

// Header.propTypes = {
//   siteTitle: PropTypes.string,
// }

// Header.defaultProps = {
//   siteTitle: `brand`,
// }
